import { Component, OnInit, ViewChild } from '@angular/core';
import { Invitations } from 'src/app/entity/invitation';
import { InvitationVisaService } from 'src/app/service/invitation.visa.service';
import { MailsService } from 'src/app/service/mails.service';
import { ComposeMailComponent } from 'src/app/view/email/include/compose-mail/compose-mail.component';
import { Contact } from 'src/app/entity/Contact';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-inviationsvisa',
  templateUrl: './inviationsvisa.component.html',
  styleUrls: ['./inviationsvisa.component.css']
})
export class InviationsvisaComponent implements OnInit {
  selectedInvitation: Invitations ;
  invitations: Invitations[];
  isSigner: boolean;
  uploadedFiles: any[];
  value:string="ddffd"
  types: SelectItem[];
  selectedType: string='napec';
  @ViewChild(ComposeMailComponent )
  private composeMailComponent: ComposeMailComponent;
 
  constructor(private invitationVisaService: InvitationVisaService,private mailsService:MailsService) { }

  ngOnInit() {
    this.findAll();
    this.types = [
      {label: 'Napec Guest', value: 'guest'},
      {label: 'NAPEC Clients', value: 'napec'} 
  ];
  window.open('http://admin-pc:8080/MISENAPEC/faces/app/visaFormTbl/index1.xhtml','_blank');
   
  }


  
  findAll() {
    this.invitationVisaService.findByType(this.selectedType ).subscribe(result => {
      this.invitations = result;
 
 
    });

  }


  updateInviation(inviation:Invitations){


    //console.log('input');
    
    this.invitationVisaService.updateInvitations(inviation).subscribe(
      result=>{
  
      }
    )
  }
  printInvitation(type: string, typeInvitation: string ) {
    //console.log('this.isSigner' + this.isSigner);

    this.invitationVisaService.printInvitations(type,this.isSigner, typeInvitation, this.selectedInvitation.id_invitation).subscribe(
      (res: any) => {

        var filename = 'invitationvisa.' + type;

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
        var FileSaver = require('file-saver');
        FileSaver.saveAs(res, filename);

        var fileURL = URL.createObjectURL(res);
        window.open(fileURL);
 
      }
    );
  }

  sendVisa() {


    this.uploadedFiles = []


    //console.log('this.isSigner' + this.isSigner);

    this.invitationVisaService.printInvitations('pdf',this.isSigner, 'i', this.selectedInvitation.id_invitation).subscribe(
      (res: any) => {

        var filename = 'invitationvisa' +'.pdf';
        res.name = filename;
        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
        this.mailsService.findodel(49).subscribe(result => {
          //  prepareEmailModel(modelCores: Modelcores, contact: Contact, projet: string, prospect: Prospect, uploadedFiles: any[])
          let contact=new Contact()
          contact.mail= this.selectedInvitation.email;

          this.uploadedFiles.push(res);
          this.composeMailComponent.prepareEmailModel(result,contact, '', null, this.uploadedFiles)
        })

 
 
      }
    );



 
  }

}
